import React,{forwardRef} from 'react'
import ServiceAttributeAssociationForm from './ServiceAttributeAssociationForm';

const AddServiceAttributeAssociation = forwardRef((props, ref) => {
    const {
        formData,
        saveServiceAttributeAssociate,
        serviceAttributeAssUpdateData,
        formValidateError,
        isButtonLoader
    } = props;
    return (
        <>
            <ServiceAttributeAssociationForm
                formValidateError = {formValidateError}
                formData={formData}
                saveServiceAttributeAssociate={saveServiceAttributeAssociate}
                serviceAttributeAssUpdateData={serviceAttributeAssUpdateData}
                formActionType={'insert'}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
                isButtonLoader={isButtonLoader}
            />
        </>
    )
})

export default AddServiceAttributeAssociation